export const TOPSIDES_DIVISION_ID = '63f72a6993d6b562d5ebabc6';
export const ERHA_FPSO_ID = '635bcaf26ea4bbbf94cdbb06';
export const USAN_FPSO_ID = '659ff017483dd2e5d221e5ac';
export const BONGA_FPSO_ID = '641596c435a9870ed54dcb5b';
export const EXXONMOBIL_ID = '635bcac46ea4bbbf94cdbaf8';
export const LNG_ID = '6788bb94649d8d1bdebc49f7';
export const SHELL_ID = '6415935f35a9870ed54dcaa7'
export const SUPER_ADMIN_ID = '635bc5435be36a9552c1100c';
export const PCNL_ID = '665cdfa9995921a9b7a7be61';
export const USERS_WITH_VIEW_ALL_REPORTS_PERMISSION = ['666c0da56f463b668b2f9d23', '65d7155b13abac9231544820', SUPER_ADMIN_ID];
export const LARGE_REPORTS = ['65fafb3fb109c1c9974f22a6', '6656e9e67435da7d69088215', '664b3edf93d1fb3226a27ab2'];
export const JEEVA_LPT_ID = '66dd2416d8bb7f62f2d1bd3f';